<template>
  <div class="register">
    <!-- 引入公共头部 :showBack="true" :showEdit="true"-->
    <dg-header :showBack="true" title="注册"></dg-header>
    <div class="register-wrap">
      <!-- logo -->
      <div class="register-header">
        <div class="register-header-span">
          <img src="../../../assets/images/logo.png" alt="">
        </div>
      </div>
      <div class="submit-content">
        <!-- 账号 -->
        <div class="submit-form-item">
          <span class="user-phone-icon"></span>
          <input class="" type="text" placeholder="请输入账号">
        </div>
        <!-- 密码 -->
        <div class="submit-form-item">
          <span class="user-pwd-icon"></span>
          <input class="" type="text" placeholder="8-13位字母或数字">
          <span class="hide-icon"></span>
        </div>
        <!-- 验证码 -->
        <div class="form-item-verify">
          <div class="submit-form-item">
            <span class="verify-icon"></span>
            <input class="" type="text" placeholder="输入验证码">
          </div>
          <button class="verify-btn">发送验证码</button>
        </div>
        <!-- 注册按钮 -->
        <div class="form-footer-btn">
          <button class="submit-form-btn login-btn">注册</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DgHeader from "@/components/header";
export default {
  data () {
    return {
      
    }
  },
  components: {
    DgHeader
  }
}
</script>
<style lang="scss" scoped>
.register-wrap{
  width: 100%;
  height: auto;
  padding: 0 30px;
  box-sizing: border-box;
  .register-header{
    width: 100%;
    height: 170px;
    background: $bg01;
    text-align: center;
    .register-header-span{
      width: 200px;
      height: 200px;
      background: $bg02;
      display: inline-block;
      margin: 0 auto;
      border-radius: 50%;
      overflow: hidden;
      padding: 40px;
      box-sizing: border-box;
      margin-top: 70px;
      >img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .submit-content{
    width: 100%;
    height: auto;
    background: $bg02;
    padding: 130px 30px;
    box-sizing: border-box;
    border-radius: $br30;
    box-shadow: $box-shadow3;
    .form-item-verify{
      display: flex;
      background: none;
      margin-bottom: 80px;
      >.verify-btn{
        background: $btn02;
        @include resetButton();
        width: 320px;
        height: 80px;
        border-radius: $br40;
        text-align: center;
        margin-left: 20px;
        color: $fc02;
        box-sizing: border-box;
        font-size: 28px;
      }
    }
    .submit-form-item{
      width: 100%;
      height: 80px;
      line-height: 80px;
      background: $bg01;
      border-radius: $br50;
      overflow: hidden;
      display: flex;
      align-items: center;
      padding: 0 40px;
      box-sizing: border-box;
      margin-bottom: 30px;
      >span{
        width: 40px;
        height: 40px;
        display: inline-block;
        margin-right: 24px;
        &.user-phone-icon{
          background: url('../../../assets/images/phone-icon.png') no-repeat 0 0/100%;
        }
        &.user-pwd-icon{
          background: url('../../../assets/images/pwd-icon.png') no-repeat 0 0/100%;
        }
        &.hide-icon{
          background: url('../../../assets/images/hide-icon.png') no-repeat 0 0/100%;
          margin-right: 0;
        }
        &.show-icon{
          background: url('../../../assets/images/show-icon.png') no-repeat 0 0/100%;
        }
        &.verify-icon{
          background: url('../../../assets/images/verify-icon.png') no-repeat 0 0/100%;
        }
      }
      >input{
        flex: 1;
        background: none;
        font-size: 30px;
        color: $fc06;
        overflow: hidden;
      }
    }
    // 忘记密码
    .forget-pwd-p{
      width: 100%;
      text-align: right;
      margin-bottom: 40px;
      >a{
        display: inline-block;
        font-size: 28px;
        color: $fc09;
      }
    }
    .submit-form-btn{
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      display: block;
      border-radius: $br50;
      overflow: hidden;
      @include resetButton();
      background: none;
      font-size: 32px;
      &.login-btn{
        background: $bg03;
        color: $fc02;
        margin-bottom: 30px;
      }
      &.register-btn{
        border: 2px solid $bc05;
        color: $fc07;
      }
    }
  }
}
</style>
